<template>
  <div>
    <search-esim-inventory-import-records @submit="submitSearch" />

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <div slot="operation_no" slot-scope="operation_no, record">
        <router-link :to="{ name: 'batch_operation_record_info', params: { id: record.id }}">
          {{ operation_no }}
        </router-link>
      </div>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findEsimInventoryImportRecords } from '@/api/esim_inventory'
import Pagination from '@/components/Pagination'
import SearchEsimInventoryImportRecords from '@/views/esim_inventories/import_records/Search'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'EsimInventoryImportRecords',
  components: {
    SearchEsimInventoryImportRecords,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: { total_count: 0 },
      query: {},
      columns: [
        {
          title: '入库批次',
          dataIndex: 'operation_no',
          fixed: 'left',
          width: 120,
          scopedSlots: { customRender: 'operation_no' }
        },
        { title: 'eSIM供应商', width: 140, dataIndex: 'esim_supplier_name' },
        { title: 'eIM平台', width: 120, dataIndex: 'eim_platform_name' },
        { title: '卡片材质', width: 120, dataIndex: 'card_type_name' },
        { title: '卡片尺寸', width: 120, dataIndex: 'card_shape_name' },
        { title: '入库成功数', width: 100, dataIndex: 'success_count' },
        { title: '生产批次', width: 160, dataIndex: 'production_batch' },
        { title: '生产日期', width: 120, dataIndex: 'production_date' },
        { title: '库房位置', width: 140, dataIndex: 'warehouse_location_name' },
        {
          title: '制卡费',
          width: 100,
          dataIndex: 'card_fee',
          customRender: (t) => formatFloat(t)
        },
        {
          title: '总制卡费',
          width: 110,
          dataIndex: 'total_card_fee',
          customRender: (t) => formatFloat(t)
        },
        { title: '状态', width: 100, dataIndex: 'status' },
        { title: '备注', width: 160, dataIndex: 'remark', ellipsis: true },
        { title: '入库时间', width: 170, dataIndex: 'created_at' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findEsimInventoryImportRecords(this.query).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
